export { getOnboardStatus, submitPaypal, putStepsDone, submitSupportTicket };

const submitPaypal = (id, paypalEmail) => {
  return fetch(`${process.env.REACT_APP_API_HOST}api/onboards/${id}/paypal`, {
    method: "put",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ paypalEmail }),
  });
};

const putStepsDone = (id, body) => {
  return fetch(`${process.env.REACT_APP_API_HOST}api/onboards/${id}/steps`, {
    method: "put",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  })
    .then(res =>
      res.json().then(json => {
        if (!res.ok) throw new Error(json.message || res.statusText);
        return json;
      })
    )
    .catch(err => {
      return Promise.reject(new Error(err.message));
    });
};

const getOnboardStatus = (id, body) => {
  return fetch(`${process.env.REACT_APP_API_HOST}api/onboards/${id}/status`)
    .then(res =>
      res.json().then(json => {
        if (!res.ok) throw new Error(json.message || res.statusText);
        return json;
      })
    )
    .catch(err => {
      return Promise.reject(new Error(err.message));
    });
};

const submitSupportTicket = (id, body) => {
  return fetch(`${process.env.REACT_APP_API_HOST}api/onboards/${id}/support`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });
};

// const getPostAndCampaign = id => {
//   return fetch(`${process.env.REACT_APP_API_HOST}api/posts/${id}/campaigns`)
//     .then(res =>
//       res.json().then(json => {
//         if (!res.ok) throw new Error(json.message || res.statusText);
//         return json;
//       })
//     )
//     .catch(err => {
//       return Promise.reject(new Error(err.message));
//     });
// };
